import { Leer, SeitenKopf } from '../komponenten/Grundbausteine';
import type { NavPunkt } from '../navigation';

/** Seite, die noch nicht gebaut ist: Leerzustand mit der Etappe, in der sie kommt (Muster wie im Prototyp). */
export function Platzhalter({ punkt, etappe }: { punkt: NavPunkt; etappe: string }) {
  return (
    <>
      <SeitenKopf titel={punkt.titel} zusatz="noch nicht gebaut" />
      <section className="panel">
        <Leer symbol={punkt.symbol} titel={`Kommt mit ${etappe}`}>
          <p>Diese Seite sieht später genau so aus wie im Prototyp.</p>
          <p className="meta">Reihenfolge des Baus: Grundgerüst, Akquise, CRM, Buchhaltung, Kunden.</p>
        </Leer>
      </section>
    </>
  );
}
